import type { AnalyticsSummary } from '../model/types'

/**
 * Источники, у которых данные неполные, устарели или с примечанием, и число чеков без достоверной даты — таблицей, а не фразами.
 * Если всё получено полностью, ничего не рисуется.
 */
export function SourceProblems({ summary, timeZoneId }: { summary: AnalyticsSummary | undefined; timeZoneId: string }) {
  const problems = (summary?.sources ?? []).filter((source) => !source.complete || source.stale || source.note !== null || source.historyComplete === false)
  const undated = summary?.undatedCount ?? 0
  if (problems.length === 0 && undated === 0) return null
  return <>
    {problems.length > 0 && <div className="krp-receipt-table-wrap"><table className="krp-receipt-table" aria-label="Источники с неполными данными">
      <thead><tr><th scope="col">Источник</th><th scope="col">Данные</th><th scope="col">Получены</th><th scope="col">История</th><th scope="col">Примечание</th></tr></thead>
      <tbody>{problems.map((source) => <tr key={source.resourceId}>
        <th scope="row">{source.name}</th>
        <td>{[source.complete ? 'полные' : 'неполные', source.stale ? 'сохранённый снимок' : null].filter((part) => part !== null).join(' · ')}</td>
        <td>{source.observedAt === null ? '—' : new Date(source.observedAt).toLocaleString('ru-RU', { timeZone: timeZoneId })}</td>
        <td>{source.historyComplete === false ? 'не подтверждена' : '—'}</td>
        <td>{source.note ?? '—'}</td>
      </tr>)}</tbody>
    </table></div>}
    {undated > 0 && <div className="krp-receipt-table-wrap"><table className="krp-receipt-table" aria-label="Чеки без даты">
      <tbody><tr><th scope="row">Чеков без достоверной даты</th><td>{undated}</td></tr></tbody>
    </table></div>}
  </>
}
